import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { useSEO, generateWebPageSchema } from '../../utils/seo';

export default function Confiance() {
  // SEO Configuration
  useSEO({
    title: 'PRT Propreté -Pourquoi nous faire confiance',
    description: 'Chez PRT Propreté, nous mettons notre expertise professionnelle au service de votre véhicule. Avec nos Pack Premium (60 €) et Pack Luxe (80 €), bénéficiez d\'un lavage intérieur et extérieur de qualité supérieure, réalisé avec soin. Nous proposons un déplacement gratuit dans un rayon de 35 km autour de Creil pour plus de confort. Faites-nous confiance pour offrir à votre voiture un nettoyage impeccable et un service fiable.',
    keywords: 'lavage auto Creil, préparateur auto, nettoyage voiture, detailing auto, lavage intérieur, lavage extérieur, Creil 60',
    schema: generateWebPageSchema('Pourquoi Nous Faire Confiance - PRT Propreté', 'Un service professionnel qui fait toute la différence')
  });

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#1a1a3e] via-[#2d2d6e] to-[#4a4aaa]">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-24 sm:pt-28 md:pt-32 pb-10 sm:pb-12 md:pb-16 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 px-2">
            Pourquoi Nous Faire Confiance ?
          </h1>
          <p className="text-base sm:text-lg md:text-xl text-gray-300 max-w-3xl mx-auto px-2">
            Un service professionnel qui fait toute la différence pour votre véhicule
          </p>
        </div>
      </section>

      {/* Main Benefits */}
      <section className="py-10 sm:py-12 md:py-16 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-6 sm:gap-8 md:gap-12 mb-12 sm:mb-16 md:mb-20">
            {/* Qualité du Travail */}
            <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 hover:bg-white/10 transition-all duration-300">
              <div className="w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 bg-cyan-400/20 rounded-full flex items-center justify-center mb-4 sm:mb-6">
                <i className="ri-star-line text-3xl sm:text-4xl md:text-5xl text-cyan-400"></i>
              </div>
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-3 sm:mb-4">Qualité du Travail</h2>
              <p className="text-gray-300 text-sm sm:text-base md:text-lg leading-relaxed mb-4 sm:mb-6">
                Nous apportons un soin méticuleux à chaque prestation. Notre objectif est de vous offrir un résultat impeccable qui dépasse vos attentes.
              </p>
              <ul className="space-y-3 sm:space-y-4">
                <li className="flex items-start text-gray-300">
                  <i className="ri-check-line text-cyan-400 text-lg sm:text-xl mr-2 sm:mr-3 mt-0.5"></i>
                  <span className="text-sm sm:text-base">Attention portée aux moindres détails</span>
                </li>
                <li className="flex items-start text-gray-300">
                  <i className="ri-check-line text-cyan-400 text-lg sm:text-xl mr-2 sm:mr-3 mt-0.5"></i>
                  <span className="text-sm sm:text-base">Techniques professionnelles éprouvées</span>
                </li>
                <li className="flex items-start text-gray-300">
                  <i className="ri-check-line text-cyan-400 text-lg sm:text-xl mr-2 sm:mr-3 mt-0.5"></i>
                  <span className="text-sm sm:text-base">Résultats visibles et durables</span>
                </li>
                <li className="flex items-start text-gray-300">
                  <i className="ri-check-line text-cyan-400 text-lg sm:text-xl mr-2 sm:mr-3 mt-0.5"></i>
                  <span className="text-sm sm:text-base">Engagement qualité sur chaque prestation</span>
                </li>
              </ul>
            </div>

            {/* Produits Professionnels */}
            <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 hover:bg-white/10 transition-all duration-300">
              <div className="w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 bg-cyan-400/20 rounded-full flex items-center justify-center mb-4 sm:mb-6">
                <i className="ri-flask-line text-3xl sm:text-4xl md:text-5xl text-cyan-400"></i>
              </div>
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-3 sm:mb-4">Produits Professionnels</h2>
              <p className="text-gray-300 text-sm sm:text-base md:text-lg leading-relaxed mb-4 sm:mb-6">
                Nous utilisons exclusivement des produits professionnels de haute qualité, spécialement conçus pour l'entretien automobile.
              </p>
              <ul className="space-y-3 sm:space-y-4">
                <li className="flex items-start text-gray-300">
                  <i className="ri-check-line text-cyan-400 text-lg sm:text-xl mr-2 sm:mr-3 mt-0.5"></i>
                  <span className="text-sm sm:text-base">Produits adaptés à chaque surface</span>
                </li>
                <li className="flex items-start text-gray-300">
                  <i className="ri-check-line text-cyan-400 text-lg sm:text-xl mr-2 sm:mr-3 mt-0.5"></i>
                  <span className="text-sm sm:text-base">Formules respectueuses des matériaux</span>
                </li>
                <li className="flex items-start text-gray-300">
                  <i className="ri-check-line text-cyan-400 text-lg sm:text-xl mr-2 sm:mr-3 mt-0.5"></i>
                  <span className="text-sm sm:text-base">Efficacité maximale garantie</span>
                </li>
                <li className="flex items-start text-gray-300">
                  <i className="ri-check-line text-cyan-400 text-lg sm:text-xl mr-2 sm:mr-3 mt-0.5"></i>
                  <span className="text-sm sm:text-base">Produits professionnels haut de gamme</span>
                </li>
              </ul>
            </div>

            {/* Respect des Véhicules */}
            <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 hover:bg-white/10 transition-all duration-300">
              <div className="w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 bg-cyan-400/20 rounded-full flex items-center justify-center mb-4 sm:mb-6">
                <i className="ri-car-line text-3xl sm:text-4xl md:text-5xl text-cyan-400"></i>
              </div>
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-3 sm:mb-4">Respect des Véhicules</h2>
              <p className="text-gray-300 text-sm sm:text-base md:text-lg leading-relaxed mb-4 sm:mb-6">
                Votre véhicule est précieux. Nous le traitons avec le plus grand soin, comme s'il était le nôtre.
              </p>
              <ul className="space-y-3 sm:space-y-4">
                <li className="flex items-start text-gray-300">
                  <i className="ri-check-line text-cyan-400 text-lg sm:text-xl mr-2 sm:mr-3 mt-0.5"></i>
                  <span className="text-sm sm:text-base">Manipulation délicate et professionnelle</span>
                </li>
                <li className="flex items-start text-gray-300">
                  <i className="ri-check-line text-cyan-400 text-lg sm:text-xl mr-2 sm:mr-3 mt-0.5"></i>
                  <span className="text-sm sm:text-base">Protection des surfaces sensibles</span>
                </li>
                <li className="flex items-start text-gray-300">
                  <i className="ri-check-line text-cyan-400 text-lg sm:text-xl mr-2 sm:mr-3 mt-0.5"></i>
                  <span className="text-sm sm:text-base">Respect de l'intégrité du véhicule</span>
                </li>
                <li className="flex items-start text-gray-300">
                  <i className="ri-check-line text-cyan-400 text-lg sm:text-xl mr-2 sm:mr-3 mt-0.5"></i>
                  <span className="text-sm sm:text-base">Soin apporté à chaque détail</span>
                </li>
              </ul>
            </div>

            {/* Satisfaction Client */}
            <div className="bg-gradient-to-br from-cyan-400/20 to-blue-500/20 backdrop-blur-md border-2 border-cyan-400/50 rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10">
              <div className="w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 bg-cyan-400/30 rounded-full flex items-center justify-center mb-4 sm:mb-6">
                <i className="ri-thumb-up-line text-3xl sm:text-4xl md:text-5xl text-cyan-400"></i>
              </div>
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-3 sm:mb-4">Satisfaction Client</h2>
              <p className="text-gray-300 text-sm sm:text-base md:text-lg leading-relaxed mb-4 sm:mb-6">
                Votre satisfaction est notre priorité absolue. Nous mettons tout en œuvre pour que vous soyez pleinement satisfait de notre service.
              </p>
              <ul className="space-y-3 sm:space-y-4">
                <li className="flex items-start text-gray-300">
                  <i className="ri-check-line text-cyan-400 text-lg sm:text-xl mr-2 sm:mr-3 mt-0.5"></i>
                  <span className="text-sm sm:text-base">Écoute attentive de vos besoins</span>
                </li>
                <li className="flex items-start text-gray-300">
                  <i className="ri-check-line text-cyan-400 text-lg sm:text-xl mr-2 sm:mr-3 mt-0.5"></i>
                  <span className="text-sm sm:text-base">Service personnalisé et adapté</span>
                </li>
                <li className="flex items-start text-gray-300">
                  <i className="ri-check-line text-cyan-400 text-lg sm:text-xl mr-2 sm:mr-3 mt-0.5"></i>
                  <span className="text-sm sm:text-base">Disponibilité et réactivité</span>
                </li>
                <li className="flex items-start text-gray-300">
                  <i className="ri-check-line text-cyan-400 text-lg sm:text-xl mr-2 sm:mr-3 mt-0.5"></i>
                  <span className="text-sm sm:text-base">Engagement satisfaction garantie</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Benefits */}
      <section className="py-10 sm:py-12 md:py-16 px-4 bg-white/5 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 sm:mb-12 md:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-2 sm:mb-4">Nos Avantages</h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-300">Ce qui nous distingue de la concurrence</p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
            <div className="bg-[#1a1a3e]/50 backdrop-blur-md border border-white/10 rounded-xl sm:rounded-2xl p-4 sm:p-6 md:p-8 text-center hover:bg-[#1a1a3e]/70 transition-all duration-300">
              <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-cyan-400/20 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4 md:mb-6">
                <i className="ri-map-pin-line text-xl sm:text-2xl md:text-3xl text-cyan-400"></i>
              </div>
              <h3 className="text-sm sm:text-lg md:text-xl font-bold text-white mb-2 sm:mb-3">Déplacement Gratuit</h3>
              <p className="text-gray-300 text-xs sm:text-sm md:text-base">
                Nous venons à vous gratuitement dans un rayon de 35kms autour de Creil
              </p>
            </div>
            
            <div className="bg-[#1a1a3e]/50 backdrop-blur-md border border-white/10 rounded-xl sm:rounded-2xl p-4 sm:p-6 md:p-8 text-center hover:bg-[#1a1a3e]/70 transition-all duration-300">
              <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-cyan-400/20 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4 md:mb-6">
                <i className="ri-time-line text-xl sm:text-2xl md:text-3xl text-cyan-400"></i>
              </div>
              <h3 className="text-sm sm:text-lg md:text-xl font-bold text-white mb-2 sm:mb-3">Flexibilité Horaire</h3>
              <p className="text-gray-300 text-xs sm:text-sm md:text-base">
                Nous nous adaptons à vos disponibilités pour un service pratique
              </p>
            </div>
            
            <div className="bg-[#1a1a3e]/50 backdrop-blur-md border border-white/10 rounded-xl sm:rounded-2xl p-4 sm:p-6 md:p-8 text-center hover:bg-[#1a1a3e]/70 transition-all duration-300">
              <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-cyan-400/20 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4 md:mb-6">
                <i className="ri-price-tag-3-line text-xl sm:text-2xl md:text-3xl text-cyan-400"></i>
              </div>
              <h3 className="text-sm sm:text-lg md:text-xl font-bold text-white mb-2 sm:mb-3">Tarifs Transparents</h3>
              <p className="text-gray-300 text-xs sm:text-sm md:text-base">
                Des prix clairs et justes, sans surprise ni frais cachés
              </p>
            </div>
            
            <div className="bg-[#1a1a3e]/50 backdrop-blur-md border border-white/10 rounded-xl sm:rounded-2xl p-4 sm:p-6 md:p-8 text-center hover:bg-[#1a1a3e]/70 transition-all duration-300">
              <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-cyan-400/20 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4 md:mb-6">
                <i className="ri-tools-line text-xl sm:text-2xl md:text-3xl text-cyan-400"></i>
              </div>
              <h3 className="text-sm sm:text-lg md:text-xl font-bold text-white mb-2 sm:mb-3">Équipement Pro</h3>
              <p className="text-gray-300 text-xs sm:text-sm md:text-base">
                Matériel de pointe pour des résultats optimaux
              </p>
            </div>
            
            <div className="bg-[#1a1a3e]/50 backdrop-blur-md border border-white/10 rounded-xl sm:rounded-2xl p-4 sm:p-6 md:p-8 text-center hover:bg-[#1a1a3e]/70 transition-all duration-300">
              <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-cyan-400/20 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4 md:mb-6">
                <i className="ri-shield-check-line text-xl sm:text-2xl md:text-3xl text-cyan-400"></i>
              </div>
              <h3 className="text-sm sm:text-lg md:text-xl font-bold text-white mb-2 sm:mb-3">Service Fiable</h3>
              <p className="text-gray-300 text-xs sm:text-sm md:text-base">
                Ponctualité et professionnalisme à chaque intervention
              </p>
            </div>
            
            <div className="bg-[#1a1a3e]/50 backdrop-blur-md border border-white/10 rounded-xl sm:rounded-2xl p-4 sm:p-6 md:p-8 text-center hover:bg-[#1a1a3e]/70 transition-all duration-300">
              <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 bg-cyan-400/20 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4 md:mb-6">
                <i className="ri-heart-line text-xl sm:text-2xl md:text-3xl text-cyan-400"></i>
              </div>
              <h3 className="text-sm sm:text-lg md:text-xl font-bold text-white mb-2 sm:mb-3">Passion du Métier</h3>
              <p className="text-gray-300 text-xs sm:text-sm md:text-base">
                Une véritable passion pour l'esthétique automobile
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-10 sm:py-12 md:py-16 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 sm:mb-12 md:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-2 sm:mb-4">Ce Que Disent Nos Clients</h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-300">La satisfaction de nos clients est notre meilleure récompense</p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
            <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-xl sm:rounded-2xl p-5 sm:p-6 md:p-8">
              <div className="flex items-center mb-3 sm:mb-4">
                <div className="flex text-cyan-400 text-base sm:text-xl">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                </div>
              </div>
              <p className="text-gray-300 mb-4 sm:mb-6 italic text-sm sm:text-base">
                "Service impeccable ! Mon véhicule est comme neuf. Je recommande vivement PRT Proprete pour leur professionnalisme."
              </p>
              <div className="flex items-center">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-cyan-400/20 rounded-full flex items-center justify-center mr-3 sm:mr-4">
                  <i className="ri-user-line text-cyan-400 text-lg sm:text-xl"></i>
                </div>
                <div>
                  <p className="text-white font-bold text-sm sm:text-base">Sophie M.</p>
                  <p className="text-gray-400 text-xs sm:text-sm">Cliente satisfaite</p>
                </div>
              </div>
            </div>
            
            <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-xl sm:rounded-2xl p-5 sm:p-6 md:p-8">
              <div className="flex items-center mb-3 sm:mb-4">
                <div className="flex text-cyan-400 text-base sm:text-xl">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                </div>
              </div>
              <p className="text-gray-300 mb-4 sm:mb-6 italic text-sm sm:text-base">
                "Excellent travail ! L'intérieur de ma voiture n'a jamais été aussi propre. Service rapide et efficace."
              </p>
              <div className="flex items-center">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-cyan-400/20 rounded-full flex items-center justify-center mr-3 sm:mr-4">
                  <i className="ri-user-line text-cyan-400 text-lg sm:text-xl"></i>
                </div>
                <div>
                  <p className="text-white font-bold text-sm sm:text-base">Thomas L.</p>
                  <p className="text-gray-400 text-xs sm:text-sm">Client régulier</p>
                </div>
              </div>
            </div>
            
            <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-xl sm:rounded-2xl p-5 sm:p-6 md:p-8">
              <div className="flex items-center mb-3 sm:mb-4">
                <div className="flex text-cyan-400 text-base sm:text-xl">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                </div>
              </div>
              <p className="text-gray-300 mb-4 sm:mb-6 italic text-sm sm:text-base">
                "Très professionnel et à l'écoute. Le résultat dépasse mes attentes. Je ferai appel à eux régulièrement."
              </p>
              <div className="flex items-center">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-cyan-400/20 rounded-full flex items-center justify-center mr-3 sm:mr-4">
                  <i className="ri-user-line text-cyan-400 text-lg sm:text-xl"></i>
                </div>
                <div>
                  <p className="text-white font-bold text-sm sm:text-base">Marie D.</p>
                  <p className="text-gray-400 text-xs sm:text-sm">Cliente fidèle</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 sm:py-16 md:py-20 px-4 bg-white/5 backdrop-blur-sm">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6">
            Convaincu ? Contactez-Nous !
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-300 mb-6 sm:mb-8 md:mb-10 px-2">
            Faites confiance à PRT Proprete pour redonner tout son éclat à votre véhicule
          </p>
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center items-center">
            <Link 
              to="/contact" 
              className="whitespace-nowrap w-full sm:w-auto px-8 sm:px-10 py-4 sm:py-5 bg-cyan-400 text-[#1a1a3e] rounded-full text-base sm:text-lg font-bold hover:bg-cyan-300 transition-all duration-300 shadow-lg hover:shadow-cyan-400/50 hover:scale-105 cursor-pointer"
            >
              Demander un devis
            </Link>
            <a 
              href="tel:0776969414" 
              className="whitespace-nowrap w-full sm:w-auto px-8 sm:px-10 py-4 sm:py-5 bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 rounded-full text-base sm:text-lg font-bold hover:bg-white/20 transition-all duration-300 cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              07.76.96.94.14
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
